import { SignUp } from "@clerk/clerk-react";
import { PageContainer } from "../components/layout/PageContainer";

export function SignUpPage() {
  return (
    <PageContainer>
      <div className="flex justify-center py-12">
        <SignUp
          routing="path"
          path="/signup"
          signInUrl="/login"
          fallbackRedirectUrl="/onboarding"
          appearance={{
            elements: {
              rootBox: "mx-auto",
              card: "bg-card border border-border/50",
            },
          }}
        />
      </div>
    </PageContainer>
  );
}
